export enum TipoConsulta {

    CONSULTA_MENSAJE = 1,
    CONSULTA_RESPUESTA = 2
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_tabla_historicos/modelo/TipoConsulta.ts